import { useEffect, useState } from 'react';

type DropdownRef = React.RefObject<HTMLElement>;

const useHandleCloseDropdownMenu = (wrapperRef: DropdownRef): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useState(false);

    useEffect(() => {
        if (typeof document === 'undefined') {
            return;
        }

        const handleClickOutside = (event: MouseEvent): void => {
            const target = event.target as Node | null;
            if (isOpenDropdownMenu && wrapperRef.current && target && !wrapperRef.current.contains(target)) {
                setOpenDropdownMenu(false);
            }
        };

        const keyPressHandler = (event: KeyboardEvent): void => {
            if (event.key === 'Escape' && isOpenDropdownMenu) {
                setOpenDropdownMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', keyPressHandler);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', keyPressHandler);
        };
    }, [isOpenDropdownMenu, wrapperRef]);

    return [isOpenDropdownMenu, setOpenDropdownMenu];
};

export { useHandleCloseDropdownMenu };
